import useDefaultExclusionCheck from '@/composables/exclusion-checks';
import useExclusion from '@/composables/exclusion';
import useRepo from '@/nebula/repo';
import { AND, combine } from 'shared/api/query/filter';
import { COUNT, RESULT } from 'shared/api/query/constants';
import { goalActivity as goalActivityConfig } from 'shared/api/query/configs.json';
import { goalActivityList } from '@/api/query/nebula/goal-activity';
import { ref } from 'vue';

export default function useGoalActivityRepo(shouldExclude) {
  const repo = useRepo(goalActivityConfig.model);
  const defaultShouldExclude = useDefaultExclusionCheck();
  const exclusion = useExclusion(repo, goalActivityConfig.model, shouldExclude ?? defaultShouldExclude.shouldExclude);

  const getListLoading = ref(false);
  const getList = ({
    filterObjects,
    order,
    pagination,
    excludeLoaded = false,
  }) => {
    const filter = combine(AND, filterObjects.filter((f) => typeof f.filterTree !== 'undefined' && f.filterTree !== null).map((f) => f.filterTree));
    const varBlocks = filterObjects.map((f) => f.varBlocks).flat();

    const handleResponse = (response) => {
      const entities = response[RESULT].map((e) => e.uid);
      const count = response[COUNT][0].count;

      return {
        goalActivities: repo.entityList.value.filter((ga) => entities.includes(ga.uid)),
        count,
      };
    };

    const handleFinally = () => {
      getListLoading.value = false;
    };

    getListLoading.value = true;

    let queries = goalActivityList({
      filter,
      order,
      pagination: {
        ...pagination,
        countAlias: COUNT,
      },
      varBlocks,
    });

    if (excludeLoaded === true) {
      queries = exclusion.applyExclusion(queries);
    }

    return repo.query(queries)
      .then(handleResponse)
      .finally(handleFinally);
  };

  return {
    ...repo,
    getListLoading,
    getList,
  };
}
